import React from 'react'
import { Link } from 'react-router-dom'

export const CompactFooter: React.FC = () => {
  return (
    <div className="bg-teal-700" style={{ marginTop: '80px' }}>
      <div className="container-custom max-w-5xl mx-auto">
        <div className="py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Legal Links */}
            <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
              <Link 
                to="https://livewello.com/privacy" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-teal-100 hover:text-white transition-colors duration-200"
              >
                Privacy Policy
              </Link>
              <span className="text-teal-600">•</span>
              <Link 
                to="https://livewello.com/terms" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-teal-100 hover:text-white transition-colors duration-200"
              >
                Terms of Service
              </Link>
            </div>

            {/* Copyright */}
            <p className="text-xs text-teal-200 text-center">
              © {new Date().getFullYear()} Livewello Spotlight. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}


